// A staff tab learns that Flow was deployed since it loaded (2026-10-07: tabs
// opened before a fix kept running, and saving with, the old code). The page
// carries the build it was served from (window.FLOW_BUILD, flow/root.py) and
// /api/extras/build/ names the one served now (plugins/flow-update.js).

export const CHECK_EVERY = 5 * 60 * 1000
// focus and visibility events come in bursts
export const MIN_GAP = 60 * 1000

export const TOAST_ID = 'flow-update'

// check() shows the notice once the tab is out of date, and says whether it
// did; while the notice is up, later deploys only change the build it covers.
// dismiss() keeps it quiet until a build newer than the one they closed the
// notice on ships.
export function createUpdateChecker ({ loaded, fetchBuild, isStaff, onUpdate, now = () => Date.now() }) {
    let lastCheck = -Infinity
    let latest = null
    let dismissed = null
    let showing = false
    async function check () {
        if (!loaded || !isStaff() || now() - lastCheck < MIN_GAP) { return false }
        lastCheck = now()
        let current
        try {
            current = (await fetchBuild())?.build
        } catch (e) {
            return false
        }
        if (!current || current === loaded || current === dismissed) { return false }
        latest = current
        if (showing) { return false }
        showing = true
        onUpdate(current)
        return true
    }
    function dismiss () {
        dismissed = latest
        showing = false
    }
    return { check, dismiss }
}

// A small note in the bottom-left corner, kept up until the tab reloads or the
// reader closes it. The checker decides when it's due: the page can't tell,
// because BootstrapVue puts a toast on the page on the next animation frame
// and a background tab gets none, so every check while hidden added one.
export function showUpdateToast (root, { onDismiss = () => {}, reload = () => window.location.reload() } = {}) {
    const h = root.$createElement
    const dismiss = () => {
        onDismiss()
        root.$bvToast.hide(TOAST_ID)
    }
    const body = h('div', { class: 'd-flex align-items-center' }, [
        h('span', { class: 'text-muted' }, 'Flow was updated.'),
        h('b-button', { class: 'p-0 ml-2', props: { size: 'sm', variant: 'link' }, attrs: { 'data-test': 'flow-update-reload' }, on: { click: reload } }, 'Reload'),
        h('b-button-close', { class: 'ml-3', props: { ariaLabel: 'Dismiss' }, attrs: { 'data-test': 'flow-update-dismiss' }, on: { click: dismiss } }),
    ])
    root.$bvToast.toast([body], {
        id: TOAST_ID,
        solid: true,
        isStatus: true,
        noAutoHide: true,
        noCloseButton: true,
        toaster: 'b-toaster-bottom-left',
        toastClass: 'flow-update-toast d-print-none',
        bodyClass: 'py-1 pl-3 pr-2',
    })
}
